import { thumbnailDemo } from '../../../demos/thumbnails.js';
import { html, cssManager } from '@design.estate/dees-element';

export const demo = () => {
  const samplePdfs = [
    'https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/examples/learning/helloworld.pdf',
    'https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf',
  ];

  const generateGridItems = (count: number) => {
    const items: ReturnType<typeof html>[] = [];
    for (let i = 0; i < count; i++) {
      const pdfUrl = samplePdfs[i % samplePdfs.length];
      items.push(html`
        <dees-thumbnail-pdf
          pdfUrl="${pdfUrl}"
          clickable="true"
          grid-mode
        ></dees-thumbnail-pdf>
      `);
    }
    return items;
  };

  return thumbnailDemo('Document thumbnails', 'A clear preview, with the details close at hand. Open a file to take a closer look.', html`

    <div class="demo-container">
      <div class="demo-section">
        <h3>Single PDF Tile</h3>
        <dees-thumbnail-pdf
          pdfUrl="https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf"
          clickable="true"
        ></dees-thumbnail-pdf>
      </div>

      <div class="demo-section">
        <h3>Different Sizes</h3>
        <div class="preview-row">
          <div class="preview-label">Small:</div>
          <dees-thumbnail-pdf
            size="small"
            pdfUrl="https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/examples/learning/helloworld.pdf"
            clickable="true"
          ></dees-thumbnail-pdf>
        </div>

        <div class="preview-row">
          <div class="preview-label">Default:</div>
          <dees-thumbnail-pdf
            pdfUrl="https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/examples/learning/helloworld.pdf"
            clickable="true"
          ></dees-thumbnail-pdf>
        </div>

        <div class="preview-row">
          <div class="preview-label">Large:</div>
          <dees-thumbnail-pdf
            size="large"
            pdfUrl="https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/examples/learning/helloworld.pdf"
            clickable="true"
          ></dees-thumbnail-pdf>
        </div>
      </div>

      <div class="demo-section">
        <h3>With Label</h3>
        <dees-thumbnail-pdf
          pdfUrl="https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf"
          clickable="true"
          label="Research Paper.pdf"
        ></dees-thumbnail-pdf>
      </div>

      <div class="demo-section">
        <h3>Non-Clickable</h3>
        <dees-thumbnail-pdf
          pdfUrl="https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/examples/learning/helloworld.pdf"
          .clickable=${false}
        ></dees-thumbnail-pdf>
      </div>

      <div class="demo-section">
        <h3>Grid - 20 PDFs with Lazy Loading</h3>
        <div class="preview-grid">
          ${generateGridItems(20)}
        </div>
      </div>
    </div>
  `);
};
